import { useGetProductGroupParameterGroupQuery } from 'Services/ProductManagement/Features/Parameter/parameterApi'
import getTranslation from 'Util/getTranslation'
import { t } from 'ttag'

interface ProductGroupOption {
  label: string
  value: string
}

interface UseProductGroupOptionsReturn {
  productGroupOptions: ProductGroupOption[] | undefined
  isProductGroupParameterGroupLoading: boolean
}

export function useProductGroupOptions(): UseProductGroupOptionsReturn {
  const {
    data: productGroupParameterGroup = null,
    isLoading: isProductGroupParameterGroupLoading
  } = useGetProductGroupParameterGroupQuery()

  const productGroupOptions = productGroupParameterGroup?.parameters.map(
    ({ translations, parameter_id }) => ({
      label: getTranslation(translations, 'fi').value,
      value: parameter_id
    })
  )

  // Add "All ticket types" option to the start of the array
  productGroupOptions?.unshift({ label: t`All ticket types`, value: '' })

  return {
    productGroupOptions,
    isProductGroupParameterGroupLoading
  }
}

export default useProductGroupOptions
